import { createComponent } from '@mtfe/sweet';
import { dom, common, eventBus } from '@mtfe/sweet-utils';

import tpl from './dom.html';
import style from './style.less';
import SearchBar from '../SearchBar/script';

const { createUniqueId } = common;
const HISTORY_ID = createUniqueId();
const SEARCH_INDEX_ID = createUniqueId();

const SearchIndexHide = () => {
    const searchIndexDom = dom.$id(SEARCH_INDEX_ID);
    if (searchIndexDom) {
        searchIndexDom.style.display = 'none';
    }
};
const SearchIndexShow = () => {
    const searchIndexDom = dom.$id(SEARCH_INDEX_ID);
    if (searchIndexDom) {
        searchIndexDom.style.display = 'block';
    }
};

const SearchIndex = async (props = {}) => {
    const { http } = props;
    try {
        // 调用搜索历史接口
        const historyInfo = await http.postSearchHistory();
        const { data: historyData = [] } = historyInfo;
        const isShowHistoryRecord = historyData.length > 0;

        const data = { isShowHistoryRecord, historyData, HISTORY_ID, SEARCH_INDEX_ID };
        const events = {
            deleteHistory: async () => {
                try {
                    await http.deleteSearchHistory();
                    const historyDom = dom.$id(HISTORY_ID);
                    if (historyDom) {
                        const parentDom = historyDom.parentElement;
                        parentDom.removeChild(historyDom);
                    }
                } catch (error) {
                    console.error('删除失败', error);
                }
                return false;
            },
            clickHistory: async (searchKeyword) => {
                SearchBar.switchToResult();
                SearchBar.setInputValue(searchKeyword);
                eventBus.$emit('click-search', SearchBar.getInputValue());
                if (window.location.hash !== '#result') {
                    window.location.replace('#result');
                }
            },
        };
        return createComponent(tpl, { data, style }, events);
    } catch (error) {
        console.error(error);
        return '';
    }
};
SearchIndex.hide = SearchIndexHide;
SearchIndex.show = SearchIndexShow;

export default SearchIndex;
